import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import TableCellPropertiesUI from './tablecellpropertiesui';
import TableCellPropertiesEditing from './tablecellpropertiesediting';

export default class TableCellProperties extends Plugin {
    /**
     * @inheritDoc
     */
    static get pluginName() {
        return 'TableCellProperties';
    }
    /**
     * @inheritDoc
     */
    static get requires() {
        return [TableCellPropertiesEditing, TableCellPropertiesUI];
    }
}
